import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceOperationResult } from "../../entities/InvoiceEntity";

/**
 * Mark Invoice As Duplicate Use Case
 * Marks an invoice as duplicate
 */
export class MarkInvoiceAsDuplicateUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(invoiceId: number): Promise<InvoiceOperationResult> {
    // Validate invoice ID
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    return await this.repository.markInvoiceAsDuplicate(invoiceId);
  }
}
